import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './JobCard.css';

const CATEGORY_MAP = {
  RESTAURANT: 'restaurant', CAFE: 'cafe', STORE: 'store',
  FACTORY: 'factory', OFFICE: 'office', TEACHING: 'teaching', OTHER: 'other',
};

function JobCard({ job }) {
  const { t } = useLanguage();
  const categoryLabel = CATEGORY_MAP[job.category] ? t(CATEGORY_MAP[job.category]) : job.category || t('other');

  return (
    <Link to={`/jobs/${job.id}`} className="job-card card">
      <div className="job-card-top">
        <span className="badge badge-blue">{categoryLabel}</span>
        {job.deadline && <span className="job-due">~{job.deadline}</span>}
      </div>
      <h3 className="job-title">{job.title}</h3>
      <p className="job-company">{job.companyName}</p>
      <div className="job-meta">
        <span>{job.location}</span>
        <span className="job-wage">{job.hourlyWage?.toLocaleString()} {t('won')}</span>
        {job.workHours && <span>{job.workHours}</span>}
      </div>
    </Link>
  );
}

export default JobCard;
